export class RestoreGoogleWorkspaceGroupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "groupRestoreScope",
            "baseName": "groupRestoreScope",
            "type": "GoogleWorkspaceGroupRestoreScope",
            "format": ""
        },
        {
            "name": "restoreTargetGroup",
            "baseName": "restoreTargetGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
